var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGripVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 4.0013C6.36811 4.0013 6.66659 3.70283 6.66659 3.33464C6.66659 2.96645 6.36811 2.66797 5.99992 2.66797C5.63173 2.66797 5.33325 2.96645 5.33325 3.33464C5.33325 3.70283 5.63173 4.0013 5.99992 4.0013Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 8.66797C6.36811 8.66797 6.66659 8.36949 6.66659 8.0013C6.66659 7.63311 6.36811 7.33464 5.99992 7.33464C5.63173 7.33464 5.33325 7.63311 5.33325 8.0013C5.33325 8.36949 5.63173 8.66797 5.99992 8.66797Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 13.3346C6.36811 13.3346 6.66659 13.0362 6.66659 12.668C6.66659 12.2998 6.36811 12.0013 5.99992 12.0013C5.63173 12.0013 5.33325 12.2998 5.33325 12.668C5.33325 13.0362 5.63173 13.3346 5.99992 13.3346Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 4.0013C10.3681 4.0013 10.6666 3.70283 10.6666 3.33464C10.6666 2.96645 10.3681 2.66797 9.99992 2.66797C9.63173 2.66797 9.33325 2.96645 9.33325 3.33464C9.33325 3.70283 9.63173 4.0013 9.99992 4.0013Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 8.66797C10.3681 8.66797 10.6666 8.36949 10.6666 8.0013C10.6666 7.63311 10.3681 7.33464 9.99992 7.33464C9.63173 7.33464 9.33325 7.63311 9.33325 8.0013C9.33325 8.36949 9.63173 8.66797 9.99992 8.66797Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 13.3346C10.3681 13.3346 10.6666 13.0362 10.6666 12.668C10.6666 12.2998 10.3681 12.0013 9.99992 12.0013C9.63173 12.0013 9.33325 12.2998 9.33325 12.668C9.33325 13.0362 9.63173 13.3346 9.99992 13.3346Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripVertical);
export default __webpack_public_path__ + "static/media/grip-vertical.c358cbff8876b2e3745e4edce6c0a2ac.svg";
export { ForwardRef as ReactComponent };